import { DraggableTypesEnum } from 'constants/builder/enums';
import { v4 as generateId } from 'uuid';

import type { QuestionnaireItems } from '../types';

export const addParagraphHelper = (
    questions: QuestionnaireItems,
    paragraphs: any[],
    clauseId: string,
    blockId: string,
    contentId: string,
    isShown?: boolean
) => {
    const fields = paragraphs
        .flat()
        .flatMap(item => item.modifiedData)
        .filter(item => item.id);

    if (!fields.length) {
        const itemsForDeleting = questions.filter(
            item =>
                item.clauseId === clauseId &&
                item.contentId === contentId &&
                item.questionType === DraggableTypesEnum.Field
        );

        return questions.filter(item => !itemsForDeleting.find(question => question.id === item.id));
    }

    const allFieldQuestions = questions.filter(item => item.questionType === DraggableTypesEnum.Field);

    questions.forEach((item, index) => {
        fields.forEach(field => {
            if (field.fieldId === item.fieldId) {
                questions.splice(index, 1);
                questions.splice(index, 0, {
                    subtitle: Array.isArray(field.value) ? field.title : field.question,
                    questionType: DraggableTypesEnum.Field,
                    description: field.description,
                    fieldId: field.fieldId,
                    value: field.value,
                    type: field.type,
                    id: generateId(),
                    title: field.id,
                    contentId,
                    clauseId,
                    blockId,
                    isShown
                });
            }
        });
    });

    fields.forEach(item => {
        if (!allFieldQuestions.find(field => field.fieldId === item.fieldId)) {
            questions.push({
                subtitle: Array.isArray(item.value) ? item.title : item.question,
                questionType: DraggableTypesEnum.Field,
                description: item.description,
                fieldId: item.fieldId,
                value: item.value,
                id: generateId(),
                type: item.type,
                title: item.id,
                contentId,
                clauseId,
                blockId,
                isShown
            });
        }
    });

    return questions;
};
